import { encodeURIParamsLegacy } from '@/_utils/encode-uri-params';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataBagService } from '../data-bag.service';
import { Data2Service } from '../data2.service';
import { DateService } from '../date.service';
import { FiltersComponent } from '../filters.component';
import { InfoboxService } from '../infobox/infobox.service';
import { LoaderService } from '../loader/loader.service';
import { QuestionService } from '../question-dialog/question-dialog.service';

@Component({
	selector: 'app-list',
	template: '',
	standalone: true,
})
export class ListComponent implements OnInit {
	tableRows: Array<any> = [];
	filters: any;
	data: any;
	parameters: any;

	protected itemsBeforeDataLoad = 0;
	protected itemsBeforeLoadData: string[] = [];
	protected apiUrl = '';
	protected filtersComponent = new FiltersComponent(this.api, this.route, this.router);
	protected apiType = 'erp';

	constructor(
		protected api: Data2Service,
		protected bag: DataBagService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected question: QuestionService,
		protected loader: LoaderService,
	) {}

	ngOnInit(): void {
		this.loader.show();
		this.loadBefore();
	}

	filtersOpen(): void {
		this.filtersComponent.filtersOpen();
	}

	filtersSelected(data): void {
		this.filters = data;
		this.loadData();
	}

	protected loadBefore(): void {
		this.loadData();
	}

	protected loadData(param?: string): void {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader.show();
		const params: string = encodeURIParamsLegacy(this.api.getChecked(this.filters, this.parameters));
		switch (this.apiType) {
			case 'erp':
				this.api.get('/' + this.apiUrl + '/?' + params, (result, error) => {
					if (error) {
						this.loader.hide();
						return;
					}
					result.data = this.convertData(result.data);
					this.data = result.data;
					this.loader.hide();
				});
				break;
			case 'bag':
				this.bag.get('/' + this.apiUrl + '/?' + params, (result, error) => {
					if (error) {
						this.loader.hide();
						return;
					}
					this.data = this.convertData(result);
					this.loader.hide();
				});
				break;
			case 'erpV2': // rewrite to something else
				this.api.get('/symfony/' + this.apiUrl + '?' + params, (result, error) => {
					if (error) {
						this.loader.hide();
						return;
					}

					this.data = result.data;
					this.loader.hide();
				});
				break;
		}
	}

	protected convertData(data: any): void {
		switch (this.apiType) {
			case 'erp':
				return data;
			case 'bag':
				return data.results;
		}
	}
}
